<template>
    <div class="relative z-20">
        <div class="hidden md:block">
            <ClientOnly>
                <Vue3Marquee
                    pause-on-hover
                    style="overflow: visible !important"
                    :duration="40">
                    <div
                        class="ml-15 flex w-full flex-nowrap items-center justify-around gap-20 text-ash-200">
                        <OurCustomersCard class="hover:text-[#0770B7]">
                            <OurCustomersRudnUniversity />
                        </OurCustomersCard>
                        <OurCustomersCard class="hover:text-[#FE001A]">
                            <OurCustomersGrandRussia />
                        </OurCustomersCard>
                        <OurCustomersCard class="hover:text-[#95F534]">
                            <OurCustomersSveza />
                        </OurCustomersCard>
                        <OurCustomersCard>
                            <OurCustomersDanone />
                        </OurCustomersCard>
                        <OurCustomersCard>
                            <OurCustomersPegasTouristik />
                        </OurCustomersCard>
                        <OurCustomersCard class="hover:text-[#0770B7]">
                            <OurCustomersSeverstal />
                        </OurCustomersCard>
                        <OurCustomersCard>
                            <OurCustomersSber />
                        </OurCustomersCard>
                        <OurCustomersCard class="hover:text-[#FF4652]">
                            <OurCustomersVDNH />
                        </OurCustomersCard>
                        <OurCustomersCard>
                            <OurCustomersGaz />
                        </OurCustomersCard>
                        <OurCustomersCard class="hover:text-[#D22630]">
                            <OurCustomersRZD />
                        </OurCustomersCard>
                        <OurCustomersCard class="hover:text-[#CB0022]">
                            <OurCustomersAriston />
                        </OurCustomersCard>
                        <OurCustomersCard>
                            <OurCustomersVolksWagen />
                        </OurCustomersCard>
                        <OurCustomersCard class="hover:text-[#FE3496]">
                            <OurCustomersT2 />
                        </OurCustomersCard>
                        <OurCustomersCard class="hover:text-[#FE001A]">
                            <OurCustomersCocaCola />
                        </OurCustomersCard>
                        <OurCustomersCard class="hover:text-[#0770B7]">
                            <OurCustomersStateDuma />
                        </OurCustomersCard>
                        <OurCustomersCard>
                            <OurCustomersMuseumFa />
                        </OurCustomersCard>
                        <OurCustomersCard class="hover:text-[#0770B7]">
                            <OurCustomersRosAtom />
                        </OurCustomersCard>
                        <OurCustomersCard class="hover:text-[#0770B7]">
                            <OurCustomersBankOfRussia />
                        </OurCustomersCard>
                        <OurCustomersCard>
                            <OurCustomersEvraz />
                        </OurCustomersCard>
                        <OurCustomersCard class="hover:text-[#D60000]">
                            <OurCustomersVseInstrumenty />
                        </OurCustomersCard>
                    </div>
                </Vue3Marquee>
            </ClientOnly>
        </div>
        <div class="container flex justify-center md:hidden">
            <OurCustomersAll />
        </div>
    </div>
</template>

<script setup lang="ts">
import { Vue3Marquee } from 'vue3-marquee'

import OurCustomersBankOfRussia from '~/components/particles/our-customers/svg/OurCustomersBankOfRussia.vue'
import OurCustomersDanone from '~/components/particles/our-customers/svg/OurCustomersDanone.vue'
import OurCustomersEvraz from '~/components/particles/our-customers/svg/OurCustomersEvraz.vue'
import OurCustomersGaz from '~/components/particles/our-customers/svg/OurCustomersGaz.vue'
import OurCustomersGrandRussia from '~/components/particles/our-customers/svg/OurCustomersGrandRussia.vue'
import OurCustomersMuseumFa from '~/components/particles/our-customers/svg/OurCustomersMuseumFa.vue'
import OurCustomersPegasTouristik from '~/components/particles/our-customers/svg/OurCustomersPegasTouristik.vue'
import OurCustomersRosAtom from '~/components/particles/our-customers/svg/OurCustomersRosAtom.vue'
import OurCustomersRudnUniversity from '~/components/particles/our-customers/svg/OurCustomersRudnUniversity.vue'
import OurCustomersSber from '~/components/particles/our-customers/svg/OurCustomersSber.vue'
import OurCustomersSeverstal from '~/components/particles/our-customers/svg/OurCustomersSeverstal.vue'
import OurCustomersStateDuma from '~/components/particles/our-customers/svg/OurCustomersStateDuma.vue'
import OurCustomersSveza from '~/components/particles/our-customers/svg/OurCustomersSveza.vue'
import OurCustomersT2 from '~/components/particles/our-customers/svg/OurCustomersT2.vue'
import OurCustomersVDNH from '~/components/particles/our-customers/svg/OurCustomersVDNH.vue'
import OurCustomersVolksWagen from '~/components/particles/our-customers/svg/OurCustomersVolksWagen.vue'

import OurCustomersCard from './OurCustomersCard.vue'
import OurCustomersAll from './svg/OurCustomersAll.vue'
import OurCustomersAriston from './svg/OurCustomersAriston.vue'
import OurCustomersCocaCola from './svg/OurCustomersCocaCola.vue'
import OurCustomersRZD from './svg/OurCustomersRZD.vue'
import OurCustomersVseInstrumenty from './svg/OurCustomersVseInstrumenty.vue'
</script>
